import { http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { LocationQuery } from 'vue-router';
import { ContractTemplate } from './contract-template.interface';

export class ContractTemplateService {
   async getContractTemplates(customerId: number, query?: LocationQuery): Promise<ApiResource<Array<ContractTemplate>>> {
      const response = await http.get<ApiResource<Array<ContractTemplate>>>(`/customers/${customerId}/contract-templates`, {
         params: { ...query },
      });
      return response.data;
   }

   async getContractTemplate(customerId: number, contractTemplateId: number): Promise<ContractTemplate> {
      const response = await http.get<ApiResource<ContractTemplate>>(`/customers/${customerId}/contract-templates/${contractTemplateId}`);
      return response.data.data;
   }

   async postContractTemplate(customerId: number, contractTemplate: ContractTemplate): Promise<ContractTemplate> {
      const response = await http.post<ApiResource<ContractTemplate>>(`/customers/${customerId}/contract-templates`, contractTemplate);
      return response.data.data;
   }

   async putContractTemplate(
      customerId: number,
      contractTemplateId: number,
      contractTemplate: ContractTemplate,
   ): Promise<ContractTemplate> {
      const response = await http.put<ApiResource<ContractTemplate>>(
         `/customers/${customerId}/contract-templates/${contractTemplateId}`,
         contractTemplate,
      );
      return response.data.data;
   }

   async deleteContractTemplate(customerId: number, contractTemplateId: number): Promise<void> {
      return await http.delete(`/customers/${customerId}/contract-templates/${contractTemplateId}`);
   }

   async calculateField(customerId: number, contractTemplateId: number, employment: any) {
      const response = await http.post<Array<{ [key: string]: any }>>(
         `/customers/${customerId}/contract-templates/${contractTemplateId}/calculate`,
         employment,
      );
      return response.data;
   }
}
